import { ActionCreatorWithPayload } from "@reduxjs/toolkit";
import { TagDescription } from "@reduxjs/toolkit/query";
import { useCallback } from "react";
import { useDispatch } from "react-redux";

type QueryTags<T> =
  //@ts-expect-error generic will have util.invalidateTags
  T["util"]["invalidateTags"] extends ActionCreatorWithPayload<
    (TagDescription<infer X> | null | undefined)[],
    string
  >
    ? X
    : never;

type ApiValidatorReturnType<T> = {
  invalidateTags: (api: T, tags: QueryTags<T>[]) => void;
};

export const useApiInvalidator = <T>(): ApiValidatorReturnType<T> => {
  const dispatch = useDispatch();
  const invalidateTags = useCallback(
    (api: T, tags: QueryTags<T>[]) => {
      //@ts-expect-error api will have util.invalidateTags
      dispatch(api.util.invalidateTags(tags as string[]));
    },
    [dispatch],
  );

  return {
    invalidateTags,
  };
};
